import { Skeleton, SimpleGrid } from "@mantine/core";

export default function RoomsSkeleton() {

  return (

    <SimpleGrid cols={3} spacing="xl">

      {[...Array(6)].map((_, i) => (

        <Skeleton
          key={i}
          height={260}
          radius="xl"
        />

      ))}

    </SimpleGrid>

  );
}